import toolLayout from '../../../layouts/tool'
import store from '../../../store'
import ua from '@/utils/ua'

export default {
  path: 'tool',
  component: toolLayout,
  children: [
    {
      path: 'excel',
      component: () => import('./excel/excel.vue'),
      meta: {
        activeMenu: 'tool',
        auth: true
      }
    },
    {
      path: 'export',
      component: () => import('./export/export.vue'),
      meta: {
        activeMenu: 'tool',
        auth: !ua.wap,
        noHeader: ua.wap
      },
      beforeEnter(to, from, next) {
        if (ua.wap) return next() // 手机端访问显示静态引导页页
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (
          ua.wap ||
          (privilege_info &&
            privilege_info.add_contacts === 'y' &&
            privilege_info.export_crm_corp === 'y')
        ) {
          next()
        } else {
          next({ path: '/noPermission' })
        }
      }
    },
    {
      path: 'googlecontact',
      component: () => import('./googlecontact/googlecontact.vue'),
      meta: {
        activeMenu: 'tool',
        auth: !ua.wap,
        noHeader: ua.wap
      },
      beforeEnter(to, from, next) {
        if (ua.wap) return next() // 手机端访问显示静态引导页页
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (
          // PrivilegeInfo.add_contacts === 'y' &&
          ua.wap ||
          (privilege_info && privilege_info.export_crm_corp === 'y')
        ) {
          next()
        } else {
          next({ path: '/card/view' })
        }
      }
    },
    {
      path: 'outlookcontact',
      component: () => import('./outlookcontact/outlookcontact.vue'),
      meta: {
        activeMenu: 'tool',
        auth: !ua.wap,
        noHeader: ua.wap
      },
      beforeEnter(to, from, next) {
        if (ua.wap) return next() // 手机端访问显示静态引导页页
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (
          // PrivilegeInfo.add_contacts === 'y' &&
          ua.wap ||
          (privilege_info && privilege_info.export_crm_corp === 'y')
        ) {
          next()
        } else {
          next({ path: '/card/view' })
        }
      }
    },
    {
      path: 'googlecontact/callback',
      component: () => import('./callback'),
      meta: {
        activeMenu: 'tool',
        auth: true
      }
    },
    {
      path: 'outlookcontact/callback',
      component: () => import('./outlookcallback'),
      meta: {
        activeMenu: 'tool',
        auth: true
      }
    },
    {
      path: 'synchronize',
      component: () => import('./synchronize/synchronize.vue'),
      meta: {
        activeMenu: 'tool',
        auth: true
      },
      beforeEnter(to, from, next) {
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (privilege_info.conf_sync_personal === 'y') {
          next()
        } else {
          next({ path: '/card/view' })
        }
      }
    },
    {
      path: 'import',
      component: () => import('./import/import.vue'),
      meta: {
        activeMenu: 'tool',
        auth: true
      },
      beforeEnter(to, from, next) {
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (privilege_info.import_excel === 'y') {
          next()
        } else {
          next({ path: '/card/view' })
        }
      }
    },
    {
      path: 'tag',
      component: () => import('./tag/tag.vue'),
      meta: {
        activeMenu: 'tool',
        auth: true
      },
      beforeEnter(to, from, next) {
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (privilege_info.manage_company_tags === 'y' || privilege_info.manage_tag_user === 'y') {
          next()
        } else {
          next({ path: '/card/view' })
        }
      }
    },
    {
      path: 'recycle',
      component: () => import('./recycle/recycle.vue'),
      meta: {
        activeMenu: 'tool',
        auth: true
      },
      beforeEnter(to, from, next) {
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (privilege_info.manage_recycle_bin === 'y') {
          next()
        } else {
          next({ path: '/card/view' })
        }
      }
    },
    {
      path: 'modifypwd',
      component: () => import('./modifypwd/modifypwd.vue'),
      meta: {
        activeMenu: 'tool',
        auth: true
      }
    }
  ]
}
